import $ from '@nuskin/nuskinjquery';
import angular from 'angular';
import '../app.js';
import {ErrorMessageCookieService} from '@nuskin/ns-shop';
import {util, RunConfigService} from '@nuskin/ns-util';
import {getStrings} from '../util/stringUtil';

'use strict';

angular.module('checkout').controller('fatalErrorCtrl', ['$scope', '$window', async function($scope, $window) {
    const runConfig = RunConfigService.getRunConfig();
    $scope.tdc = await getStrings();
    $scope.contentLoaded = false;
    $scope.error = ErrorMessageCookieService.getErrorMessages();
    $scope.contentLoaded = true;
    $scope.homeLink = '/content/nuskin/' + runConfig.language + '_' + runConfig.country + '/home.html';
    $scope.$apply();

    // When you click the home link clear errors and pass to home page
    $scope.clearFatalErrorGoHome = function() {
        $scope.error.clearErrors();
        ErrorMessageCookieService.resetErrorMessagesStorage();
        if (util.MobileUtils.isPhoneGap()) {
            window.location.href = 'index.html#/home';
        } else {
            $window.location.href = $scope.homeLink;
        }
    };

    // If you click any link and leave the fatal error page clear errors to prevent seeing elsewhere
    // This is in scope so it won't effect links outside of fatalError.jsp
    $('a:not(\'#fatalErrorHomeLink\')').click(function() {
        $scope.error.clearErrors();
    });
}]);
